import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import React, { useEffect, useState } from "react";
import KenLoader from "../../GlobalComponents/KenLoader";
import { getPlayersDetails, getTeamDetails } from "../../Utils/apiService";
import {
  extractStatByRole,
  formatToIndianCurrencyWords2,
  mapHighestLevelToCategory,
} from "../../Utils/helperFunctions";
import { useAuthStore } from "../../store";
import routes from "../../Utils/routes";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../Components/Layout/AdminLayout";
import { mcaLogo } from "../../Assets";
import {
  getAuctionRulesByDivision,
  resolveAuctionDivision,
  resolveCategoryWithFallback,
  resolveTeamDivision,
  type AuctionDivision,
} from "../../Utils/auctionRules";

const commonCellStyles = {
  color: "#fff",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  border: "none",
};

const metricCardSx = {
  px: { xs: "10px", md: "14px" },
  py: { xs: "6px", md: "12px" },
  minHeight: { xs: 20, md: 48 },
  background:
    "linear-gradient(180deg, rgba(24,26,34,0.96) 0%, rgba(16,18,24,0.96) 100%)",
  border: "1px solid rgba(255,255,255,0.12)",
  borderRadius: { xs: "10px", md: "8px" },
  backdropFilter: "blur(4px)",
  boxShadow: {
    xs: "inset 0 1px 0 rgba(255,255,255,0.06)",
    md: "none",
  },
};

const appliedChipSx = {
  backgroundColor: "rgba(255,255,255,0.08)",
  color: "#fff",
  border: "1px solid rgba(255,255,255,0.26)",
  borderRadius: "6px",
  height: { xs: 32, md: "1.8vw" },
  fontSize: { xs: "0.85rem", md: "0.8vw" },
  backdropFilter: "blur(6px)",
  "& .MuiChip-deleteIcon": {
    marginLeft: "4px",
    color: "#fff",
  },
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.14)",
  },
};

const isNAValue = (value: unknown): boolean => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");
  return (
    normalized === "" ||
    normalized === "na" ||
    normalized === "n/a" ||
    normalized === "n.a." ||
    normalized === "-" ||
    normalized === "null" ||
    normalized === "undefined"
  );
};
const controlsHeight = { xs: 40, md: "2.05vw" };

const TeamsDashboard = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [playerDetails, setplayerDetails] = useState<any>(null);
  const [TeamDetails, setTeamDetails] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  } | null>(null);
  const [roleFilter, setRoleFilter] = useState<string | null>(null);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [setFilter, setSetFilter] = useState<string | null>(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState<{
    role?: string;
    category?: string;
    status?: string;
    set?: string;
  }>({});
  const [filterMenu, setFilterMenu] = useState(false);
  const [myTeamData, setMyTeamData] = useState<any>(null);
  const [balanceKittyAmount, setbalanceKittyAmount] = useState<any>();
  const [teamDivision, setTeamDivision] = useState<AuctionDivision>("men");
  const [activeTableTab, setActiveTableTab] = useState<"team_squad" | "auction_pool">(
    "team_squad",
  );
  const activeRules = getAuctionRulesByDivision(teamDivision);
  const kittyAllocation = activeRules.kittyAllocation;
  console.log(JSON.stringify(myTeamData), "myTeamData");

  const teamId = localStorage.getItem("teamId");

  const { teamDetailsTrigger } = useAuthStore();

  const fetchData = async () => {
    try {
      const [playersRes, teamsDetail] = await Promise.all([
        getPlayersDetails(),
        getTeamDetails(),
      ]);

      if (playersRes?.data?.success) {
        setplayerDetails(playersRes.data.data);
      }
      if (teamsDetail?.data?.success) {
        const allTeams = teamsDetail.data.data;
        const currentTeam = allTeams.find((team: any) => team.Id === teamId);
        const currentTeamDivision = resolveTeamDivision(currentTeam);
        setTeamDivision(currentTeamDivision);

        let totalkittyamt: any = 0;
        for (
          let i = 0;
          i < currentTeam?.Player_Registrations__r?.records?.length;
          i++
        ) {
          let p = currentTeam?.Player_Registrations__r?.records[i];
          console.log(p, "p");
          totalkittyamt = totalkittyamt + (p.Kitty_Bid_Amount__c || 0);
        }
        let balanceKitty = kittyAllocation - totalkittyamt;
        setbalanceKittyAmount(balanceKitty);
        console.log(balanceKitty, "balanceKitty");

        console.log(JSON.stringify(currentTeam), "currentTeam");
        setMyTeamData(currentTeam);
        setTeamDetails(
          allTeams.filter(
            (team: any) => resolveTeamDivision(team) === currentTeamDivision,
          ),
        );
        if (currentTeam?.Name) {
          setAppliedFilters((prev) => ({
            ...prev,
          }));
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [teamDetailsTrigger]);

  const handleFilterMenuToggle = () => {
    setFilterMenu((prev) => !prev);
  };

  const getPlayerCategory = (player: any) => {
    const mcaNo =
      player?.MCANo ||
      player?.MCA_No__c ||
      player?.MCA_Registration_Number__c ||
      player?.Player__r?.MCA_No__c ||
      player?.Player__r?.MCA_Registration_Number__c;
    const categoryFromKey =
      player?.category ??
      player?.Category ??
      player?.playerCategory ??
      player?.PlayerCategory ??
      player?.Player_Category__c ??
      player?.Category__c;

    if (!isNAValue(categoryFromKey)) {
      return resolveCategoryWithFallback({
        division: teamDivision,
        mcaNo,
        fallbackCategory: String(categoryFromKey).trim(),
      });
    }

    if (teamDivision === "women") {
      return resolveCategoryWithFallback({
        division: "women",
        mcaNo,
        fallbackCategory: "General Player",
      });
    }

    const mappedCategory = mapHighestLevelToCategory(
      String(player?.recentCompetetionLevel || player?.highest_level_played || ""),
    );
    if (mappedCategory && mappedCategory !== "Unknown") {
      return resolveCategoryWithFallback({
        division: "men",
        mcaNo,
        fallbackCategory: mappedCategory,
      });
    }

    return resolveCategoryWithFallback({
      division: teamDivision,
      mcaNo,
      fallbackCategory: "Uncategorized",
    });
  };

  const normalizeCategoryFilterValue = (value: string | null | undefined) => {
    const normalized = String(value || "").trim().toLowerCase();
    if (normalized === "senior player" || normalized === "senior players") {
      return "senior player";
    }
    return normalized;
  };

  const filteredTeamPlayers = (playerDetails || []).filter(
    (player: any, index: number) => {
      if (!teamId || player?.soldToId !== teamId) {
        return false;
      }
      const term = searchTerm?.toLowerCase();

      // Fallback to normal text-based search
      const matchesSearch =
        player?.name?.toLowerCase().includes(term) ||
        // player.MCANo?.toLowerCase().includes(term) ||
        player?.auctionNumber?.toString() === term;
      // mapHighestLevelToCategory(player.recentCompetetionLevel)
      //   ?.toLowerCase()
      //   .includes(term);

      const isSameDivisionAsTeam =
        resolveAuctionDivision(player?.gender) === teamDivision;
      const matchesRole =
        !appliedFilters.role || player.role === appliedFilters.role;

      const matchesCategory =
        !appliedFilters.category ||
        normalizeCategoryFilterValue(getPlayerCategory(player)) ===
          normalizeCategoryFilterValue(appliedFilters.category);
      const matchesStatus =
        !appliedFilters.status ||
        String(player?.auctionResult || "").toLowerCase() ===
          String(appliedFilters.status).toLowerCase();

      return (
        isSameDivisionAsTeam &&
        matchesSearch &&
        matchesRole &&
        matchesCategory &&
        matchesStatus
      );
    },
  );

  const filteredAuctionPoolPlayers = (playerDetails || []).filter(
    (player: any) => {
      const term = searchTerm?.toLowerCase();
      const matchesSearch =
        player?.name?.toLowerCase().includes(term) ||
        player?.auctionNumber?.toString() === term;
      const isSameDivisionAsTeam =
        resolveAuctionDivision(player?.gender) === teamDivision;
      const matchesRole =
        !appliedFilters.role || player.role === appliedFilters.role;
      const matchesCategory =
        !appliedFilters.category ||
        normalizeCategoryFilterValue(getPlayerCategory(player)) ===
          normalizeCategoryFilterValue(appliedFilters.category);
      const matchesStatus =
        !appliedFilters.status ||
        String(player?.auctionResult || "").toLowerCase() ===
          String(appliedFilters.status).toLowerCase();
      const matchesSet =
        !appliedFilters.set ||
        String(player?.set || player?.Set || player?.Set__c || "").trim() ===
          String(appliedFilters.set).trim();

      return (
        isSameDivisionAsTeam &&
        matchesSearch &&
        matchesRole &&
        matchesCategory &&
        matchesStatus &&
        matchesSet
      );
    },
  );

  const setFilterOptions = React.useMemo<string[]>(
    () =>
      Array.from(
        new Set<string>(
          (playerDetails || [])
            .filter(
              (player: any) => resolveAuctionDivision(player?.gender) === teamDivision,
            )
            .map((player: any) =>
              String(player?.set || player?.Set || player?.Set__c || "").trim(),
            )
            .filter((set: string) => Boolean(set)),
        ),
      ).sort((a: string, b: string) => a.localeCompare(b)),
    [playerDetails, teamDivision],
  );

  const sortPlayersByConfig = (players: any[]) => {
    if (!sortConfig) {
      const categoryOrder =
        teamDivision === "women"
          ? ["Icon Player", "Under-19 Player", "General Player"]
          : [
              "Icon Player",
              "Senior Player",
              "Emerging Player",
              "Development Player",
            ];
      const categoryRank = new Map(
        categoryOrder.map((category, index) => [category, index]),
      );

      return [...players].sort((a, b) => {
        const catA = getPlayerCategory(a);
        const catB = getPlayerCategory(b);
        const rankA = categoryRank.get(catA) ?? 99;
        const rankB = categoryRank.get(catB) ?? 99;
        if (rankA !== rankB) return rankA - rankB;
        return `${a?.name || ""}`.localeCompare(`${b?.name || ""}`);
      });
    }
    const sorted = [...players].sort((a, b) => {
      const valA = a[sortConfig.key]?.toLowerCase?.() || "";
      const valB = b[sortConfig.key]?.toLowerCase?.() || "";
      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  };

  const sortedTeamPlayers = React.useMemo(
    () => sortPlayersByConfig(filteredTeamPlayers),
    [filteredTeamPlayers, sortConfig, teamDivision],
  );
  const sortedAuctionPoolPlayers = React.useMemo(
    () => sortPlayersByConfig(filteredAuctionPoolPlayers),
    [filteredAuctionPoolPlayers, sortConfig, teamDivision],
  );
  const displayedPlayers =
    activeTableTab === "auction_pool"
      ? sortedAuctionPoolPlayers
      : sortedTeamPlayers;

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
    navigate(routes.login);
  };

  const openLogoutDialog = () => {
    setLogoutDialogOpen(true);
  };

  const closeLogoutDialog = () => {
    setLogoutDialogOpen(false);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const remainingFundFormatted = formatToIndianCurrencyWords2(
    myTeamData?.Fund_Remaining__c,
  );
  const teamPurseFormatted = formatToIndianCurrencyWords2(activeRules.purseMax);
  const listTitle =
    teamDivision === "women"
      ? "Women's Player list t20 Mumbai - 2026"
      : "Men's Player list t20 Mumbai - 2026";

  const teamPlayersForSummary = (playerDetails || []).filter(
    (player: any) =>
      player?.soldToId === teamId &&
      resolveAuctionDivision(player?.gender) === teamDivision,
  );

  const getCategoryCount = (category: string) =>
    teamPlayersForSummary.filter(
      (p: any) =>
        p?.soldToId === teamId &&
        p?.auctionResult === "Sold" &&
        getPlayerCategory(p) === category,
    ).length;

  const totalPlayers = teamPlayersForSummary.filter(
    (p: any) => p?.soldToId === teamId && p?.auctionResult === "Sold",
  ).length;

  const categoryMetricCards =
    teamDivision === "women"
      ? [
          {
            label: "Icon players",
            current: getCategoryCount("Icon Player"),
            min: 1,
          },
          {
            label: "Under-19 players",
            current: getCategoryCount("Under-19 Player"),
            min: 2,
          },
          {
            label: "General players",
            current: getCategoryCount("General Player"),
          },
        ]
      : [
          {
            label: "Icon players",
            current: getCategoryCount("Icon Player"),
            min: 1,
          },
          {
            label: "Senior players",
            current: getCategoryCount("Senior Player"),
            min: 3,
          },
          {
            label: "Emerging players",
            current: getCategoryCount("Emerging Player"),
            min: 3,
          },
          {
            label: "Development players",
            current: getCategoryCount("Development Player"),
            min: 5,
          },
        ];

  const categoryFilterOptions =
    teamDivision === "women"
      ? ["Icon Player", "Under-19 Player", "General Player"]
      : [
          "Icon Player",
          "Senior Player",
          "Emerging Player",
          "Development Player",
        ];

  if (!playerDetails || !TeamDetails) {
    return <KenLoader />;
  }

  return (
    <Box
      className={classes.desktopLayout}
      sx={{
        background:
          "radial-gradient(circle at 85% 10%, rgba(233,125,69,0.22), transparent 32%), #09090B",
        p: { xs: "8px", sm: "18px", md: "36px" },
        minHeight: "100dvh",
        height: { xs: "auto", md: "100vh" },
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Box
        className={classes.desktopHeader}
        sx={{
          background: "rgba(11,11,14,0.88)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "14px",
          boxSizing: "border-box",
          height: { xs: "auto", md: "80px" },
          minHeight: { xs: "64px", md: "80px" },
          mt: { xs: "4px", md: "1%" },
          px: { xs: "8px", md: "1.2%" },
          py: { xs: "8px", md: "0.4%" },
        }}
      >
        <Box
          className={classes.desktopHeaderContainer}
          sx={{
            minHeight: { xs: "auto", md: 84 },
            width: "100%",
            gap: { xs: "8px", md: 0 },
            flexWrap: "nowrap",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: "10px", md: "14px" },
              width: { xs: "auto", md: "auto" },
              flex: 1,
              minWidth: 0,
            }}
          >
            <img
              src={mcaLogo}
              style={{ height: "40px", width: "auto" }}
              alt="logo"
            />
            {myTeamData?.Logo_URL__c && (
              <Box
                component="img"
                src={myTeamData.Logo_URL__c}
                alt={myTeamData?.Name || "team"}
                sx={{
                  width: { xs: 42, md: 48 },
                  height: { xs: 42, md: 48 },
                  objectFit: "contain",
                }}
              />
            )}
            {myTeamData?.Name && (
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.9)",
                  fontWeight: 700,
                  fontSize: { xs: "0.9rem", md: "1.05rem" },
                  maxWidth: { xs: "calc(100vw - 190px)", md: "22vw" },
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {myTeamData.Name}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              ml: { xs: "8px", md: "auto" },
              width: "auto",
              flexShrink: 0,
              justifyContent: { xs: "flex-end", md: "initial" },
            }}
          >
            <Button
              variant="contained"
              onClick={() => navigate(routes.teamDashboardLivePreview)}
              sx={{
                display: { xs: "none", md: "inline-flex" },
                textTransform: "none",
                fontWeight: 800,
                fontSize: { xs: "0.9rem", md: "1rem" },
                px: { xs: "14px", md: "22px" },
                py: { xs: "9px", md: "11px" },
                borderRadius: "12px",
                background: "linear-gradient(180deg, #FF9A1A 0%, #FF7E08 100%)",
                color: "#111",
                border: "1px solid rgba(255,255,255,0.22)",
                boxShadow: "0 8px 22px rgba(255,126,8,0.34)",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '"LIVE"',
                  position: "absolute",
                  top: -1,
                  left: -1,
                  fontSize: "0.58rem",
                  fontWeight: 900,
                  letterSpacing: "0.06em",
                  color: "#fff",
                  background: "#E53935",
                  px: 0.7,
                  py: 0.2,
                  borderBottomRightRadius: "8px",
                },
                "&:hover": {
                  background: "linear-gradient(180deg, #FFAD34 0%, #FF8B12 100%)",
                  boxShadow: "0 10px 24px rgba(255,126,8,0.45)",
                },
              }}
            >
              Live Preview
            </Button>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                color: "#121212",
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: 500,
                padding: { xs: "8px 18px", md: "10px 30px" },
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "8px",
                backgroundColor: "#fff",

                textAlign: "center",
              }}
              onClick={openLogoutDialog}
            >
              Logout
            </Box>
            <IconButton
              onClick={handleMenuOpen}
              sx={{
                display: { xs: "inline-flex", md: "none" },
                ml: "auto",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "8px",
                backgroundColor: "rgba(17,17,20,0.85)",
              }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              slotProps={{
                paper: {
                  sx: {
                    backgroundColor: "rgba(17,17,20,0.98)",
                    border: "1px solid rgba(255,255,255,0.16)",
                    color: "#fff",
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  navigate(routes.teamDashboardLivePreview);
                }}
              >
                Live Preview
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  openLogoutDialog();
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
      <Dialog
        open={logoutDialogOpen}
        onClose={closeLogoutDialog}
        PaperProps={{
          sx: {
            background: "rgba(17,17,20,0.98)",
            border: "1px solid rgba(255,255,255,0.16)",
            color: "#fff",
            borderRadius: "12px",
            minWidth: { xs: "90vw", sm: "360px" },
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Confirm Logout</DialogTitle>
        <DialogContent sx={{ color: "rgba(255,255,255,0.82)", pt: "4px !important" }}>
          Are you sure you want to logout?
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={closeLogoutDialog}
            variant="outlined"
            sx={{ color: "#fff", borderColor: "rgba(255,255,255,0.35)" }}
          >
            No
          </Button>
          <Button
            onClick={handleLogout}
            variant="contained"
            sx={{ bgcolor: "#F5F5F5", color: "#111", fontWeight: 600 }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        className={classes.desktopContainer}
        sx={{
          height: { xs: "auto", md: "calc(100vh - 165px)" },
          minHeight: 0,
          display: "flex",
          overflow: "visible",
          pt: { xs: "12px", md: "12px" },
        }}
      >
        <Box
          className={classes.desktopScreen}
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            bgcolor=""
            color="#fff"
            sx={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", md: "center" },
                flexDirection: { xs: "column", md: "row" },
                marginBottom: { xs: "10px", md: "14px" },
                flexShrink: 0,
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "14px",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Box
                  sx={{
                    border: "1px solid #9a4f1d",
                    background:
                      "linear-gradient(180deg, rgba(76,35,17,0.85) 0%, rgba(49,22,11,0.85) 100%)",
                    px: { xs: "7px", md: "12px" },
                    py: { xs: "5px", md: "6px" },
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "0.95rem", md: "2.35rem" },
                      lineHeight: 1.02,
                      fontWeight: 800,
                      letterSpacing: "0.01em",
                      background:
                        "linear-gradient(180deg, #FFB347 0%, #FF7A38 68%, #FF5A2A 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    {listTitle}
                  </Typography>
                  <Box
                    sx={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      height: { xs: "2px", md: "3px" },
                      opacity: 0.9,
                      background:
                        "linear-gradient(90deg, #ff2d7a 0% 12%, #00d47a 12% 26%, #00a2ff 26% 40%, #4056ff 40% 54%, #ff7a00 54% 67%, #ff3b3b 67% 79%, #f2d200 79% 90%, #00d47a 90% 100%)",
                    }}
                  />
                </Box>
                <Box display="flex" gap={1} flexWrap="wrap">
                  {appliedFilters.role && (
                    <Chip
                      label={appliedFilters.role}
                      onDelete={() => {
                        setRoleFilter(null);
                        setAppliedFilters((prev) => ({
                          ...prev,
                          role: undefined,
                        }));
                      }}
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={appliedChipSx}
                    />
                  )}
                  {appliedFilters.category && (
                    <Chip
                      label={appliedFilters.category}
                      onDelete={() => {
                        setCategoryFilter(null);
                        setAppliedFilters((prev) => ({
                          ...prev,
                          category: undefined,
                        }));
                      }}
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={appliedChipSx}
                    />
                  )}
                  {activeTableTab === "auction_pool" && appliedFilters.status && (
                    <Chip
                      label={appliedFilters.status}
                      onDelete={() => {
                        setStatusFilter(null);
                        setAppliedFilters((prev) => ({
                          ...prev,
                          status: undefined,
                        }));
                      }}
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={appliedChipSx}
                    />
                  )}
                  {activeTableTab === "auction_pool" && appliedFilters.set && (
                    <Chip
                      label={appliedFilters.set}
                      onDelete={() => {
                        setSetFilter(null);
                        setAppliedFilters((prev) => ({
                          ...prev,
                          set: undefined,
                        }));
                      }}
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={appliedChipSx}
                    />
                  )}
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  ml: { xs: 0, md: "auto" },
                  width: { xs: "100%", md: "auto" },
                  flexWrap: "nowrap",
                }}
              >
                <TextField
                  // label="Search"
                  placeholder="Search"
                  variant="outlined"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          style={{ color: "#94969C", fontSize: "20px" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    borderRadius: "12px",
                    fontSize: "10px!important",
                    fontWeight: "350!important",
                    marginBottom: "0",
                    flex: { xs: 1, md: "none" },
                    minWidth: 0,
                    width: { xs: "auto", sm: "260px", md: "320px" },
                    color: "white",
                    "& .MuiOutlinedInput-root": {
                      minHeight: controlsHeight,
                      background: "rgba(17,17,20,0.85)",
                      "&:hover fieldset": {
                        borderColor: "#fff",
                        color: "#fff",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#7F56D9",
                      },
                      "& input": {
                        color: "#fff",
                      },
                    },
                  }}
                />
                <Box sx={{ position: "relative" }}>
                  <Box
                    sx={{
                      border: "0.8px solid rgba(255, 255, 255, 0.24)",
                      borderRadius: "6px",
                      background:
                        "linear-gradient(180deg, rgba(18,20,25,0.9) 0%, rgba(12,12,14,0.9) 100%)",
                      px: { xs: "12px", md: "0.78vw" },
                      minHeight: controlsHeight,
                      display: "flex",
                      gap: "6px",
                      cursor: "pointer",
                      alignItems: "center",
                      backdropFilter: "blur(6px)",
                      fontSize: { xs: "0.9rem", md: "0.86vw" },
                    }}
                    onClick={handleFilterMenuToggle}
                  >
                    Filter <FilterAltOutlinedIcon fontSize="small" />
                  </Box>
                  {filterMenu && (
                    <ClickAwayListener onClickAway={() => setFilterMenu(false)}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(180deg, rgba(17,17,20,0.98) 0%, rgba(11,11,15,0.98) 100%)",
                          borderRadius: "10px",
                          padding: "16px",
                          width: { xs: "min(92vw, 300px)", md: 300 },
                          zIndex: 10,
                          minHeight: "400px",
                          position: "absolute",
                          top: "60px",
                          right: "0",
                          boxShadow: "0 12px 30px rgba(0,0,0,0.45)",
                          display: "flex",
                          flexDirection: "column",
                          border: "1px solid rgba(255,255,255,0.14)",
                        }}
                      >
                        <Typography variant="h6" color="#fff" mb={2}>
                          Filters
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          value={roleFilter || ""}
                          onChange={(e) => setRoleFilter(e.target.value)}
                          SelectProps={{ native: true }}
                          sx={{ mb: 2 }}
                        >
                          <option value="">Select role</option>
                          <option value="Batsman">Batsman</option>
                          <option value="Bowler">Bowler</option>
                          <option value="Wicketkeeper">Wicketkeeper</option>
                          <option value="All - rounder">All - rounder</option>
                        </TextField>
                        <TextField
                          select
                          fullWidth
                          value={categoryFilter || ""}
                          onChange={(e) => setCategoryFilter(e.target.value)}
                          SelectProps={{ native: true }}
                          sx={{
                            mb: 2,
                            "& .MuiSelect-icon": {
                              color: "#fff",
                            },
                          }}
                        >
                          <option value="">Select Category</option>
                          {categoryFilterOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </TextField>
                        {activeTableTab === "auction_pool" && (
                          <TextField
                            select
                            fullWidth
                            value={statusFilter || ""}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            SelectProps={{ native: true }}
                            sx={{
                              mb: 2,
                              "& .MuiSelect-icon": {
                                color: "#fff",
                              },
                            }}
                          >
                            <option value="">Select Status</option>
                            <option value="Sold">Sold</option>
                            <option value="Unsold">Unsold</option>
                          </TextField>
                        )}
                        {activeTableTab === "auction_pool" && (
                          <TextField
                            select
                            fullWidth
                            value={setFilter || ""}
                            onChange={(e) => setSetFilter(e.target.value)}
                            SelectProps={{ native: true }}
                            sx={{
                              mb: 2,
                              "& .MuiSelect-icon": {
                                color: "#fff",
                              },
                            }}
                          >
                            <option value="">Select Set</option>
                            {setFilterOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </TextField>
                        )}
                        <Box display="flex" gap={2} mt={"auto"}>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setRoleFilter(null);
                              setCategoryFilter(null);
                              setStatusFilter(null);
                              setSetFilter(null);
                              setAppliedFilters({});
                            }}
                            sx={{ color: "#fff", borderColor: "#fff", flex: 1 }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() => {
                              setAppliedFilters({
                                ...(roleFilter && { role: roleFilter }),
                                ...(categoryFilter && {
                                  category: categoryFilter,
                                }),
                                ...(activeTableTab === "auction_pool" &&
                                  statusFilter && { status: statusFilter }),
                                ...(activeTableTab === "auction_pool" &&
                                  setFilter && { set: setFilter }),
                              });
                              setFilterMenu(false);
                            }}
                            sx={{
                              bgcolor: "#F5F5F5",
                              color: "#111",
                              fontWeight: 600,
                              flex: 1,
                            }}
                          >
                            Show results
                          </Button>
                        </Box>
                      </Box>
                    </ClickAwayListener>
                  )}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2, minmax(0, 1fr))",
                  sm: "repeat(3, minmax(0, 1fr))",
                  md: "repeat(4, minmax(0, 1fr))",
                  lg: "repeat(7, minmax(0, 1fr))",
                },
                gap: { xs: "8px", md: "10px" },
                mb: { xs: "10px", md: "16px" },
                flexShrink: 0,
                p: { xs: "6px", md: "8px" },
                borderRadius: { xs: "10px", md: "12px" },
                border: "1px solid rgba(255,255,255,0.08)",
                background: "rgba(11,12,16,0.72)",
              }}
            >
              <Box
                sx={{
                  gridColumn: "1 / -1",
                  display: "flex",
                  gap: { xs: "8px", md: "10px" },
                  mb: { xs: "4px", md: "6px" },
                }}
              >
                <Button
                  onClick={() => {
                    setActiveTableTab("team_squad");
                    setPage(0);
                  }}
                  sx={{
                    px: { xs: "10px", md: "14px" },
                    py: { xs: "5px", md: "6px" },
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 700,
                    border: "1px solid rgba(255,255,255,0.22)",
                    color:
                      activeTableTab === "team_squad"
                        ? "#0A0A0A"
                        : "rgba(255,255,255,0.85)",
                    background:
                      activeTableTab === "team_squad"
                        ? "linear-gradient(90deg, #FFD54F 0%, #FFA726 100%)"
                        : "rgba(255,255,255,0.06)",
                  }}
                >
                  Team Squad
                </Button>
                <Button
                  onClick={() => {
                    setActiveTableTab("auction_pool");
                    setPage(0);
                  }}
                  sx={{
                    px: { xs: "10px", md: "14px" },
                    py: { xs: "5px", md: "6px" },
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 700,
                    border: "1px solid rgba(255,255,255,0.22)",
                    color:
                      activeTableTab === "auction_pool"
                        ? "#0A0A0A"
                        : "rgba(255,255,255,0.85)",
                    background:
                      activeTableTab === "auction_pool"
                        ? "linear-gradient(90deg, #FFD54F 0%, #FFA726 100%)"
                        : "rgba(255,255,255,0.06)",
                  }}
                >
                  Auction Pool
                </Button>
              </Box>

              {activeTableTab === "team_squad" &&
                [
                  ...categoryMetricCards,
                  {
                    label: "Total players",
                    current: totalPlayers,
                    max: activeRules.squadMax,
                    min: activeRules.squadMin,
                  },
                  { label: "Team purse", value: teamPurseFormatted },
                  { label: "Fund remaining", value: remainingFundFormatted },
                ].map((item: any, idx) => (
                <Box
                  key={idx}
                  sx={{
                    ...metricCardSx,
                    gridColumn: {
                      xs: idx === 6 ? "1 / -1" : "auto",
                      lg: "auto",
                    },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: { xs: "center", md: "flex-start" },
                    minHeight: { xs: 44, md: 72 },
                    position: "relative",
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize:
                        item.label === "Team purse" ||
                        item.label === "Fund remaining"
                          ? { xs: "0.78rem", md: "2.4rem" }
                          : { xs: "0.9rem", md: "2.8rem" },
                      color: "#fff",
                      lineHeight: { xs: 1.05, md: 1 },
                      letterSpacing: "-0.01em",
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    {typeof item.current === "number" &&
                    typeof item.max === "number" ? (
                      <>
                        <Box
                          component="span"
                          sx={{
                            color:
                              item.label === "Total players"
                                ? item.current >= (item.min ?? 0)
                                  ? "#4CAF50"
                                  : "#EF5350"
                                : "#fff",
                          }}
                        >
                          {item.current}
                        </Box>
                        /{item.max}
                      </>
                    ) : typeof item.current === "number" ? (
                      item.current
                    ) : (
                      item.value
                    )}
                  </Typography>
                  <Box
                    sx={{
                      mt: { xs: "0px", md: "4px" },
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      flexWrap: "nowrap",
                      justifyContent: { xs: "center", md: "flex-start" },
                      minHeight: { xs: 18, md: 28 },
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize:
                          item.label === "Team purse" ||
                          item.label === "Fund remaining"
                            ? { xs: "0.62rem", md: "1rem" }
                            : { xs: "0.62rem", md: "0.95rem" },
                        textTransform: "capitalize",
                        color: "rgba(255,255,255,0.74)",
                        letterSpacing: { xs: "0.01em", md: 0 },
                        textAlign: { xs: "center", md: "left" },
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.label}
                    </Typography>
                    {typeof item.min === "number" &&
                    item.label !== "Icon players" ? (
                      <Box
                        sx={{
                          position: "absolute",
                          top: { xs: "8px", md: "10px" },
                          right: { xs: "8px", md: "10px" },
                          px: { xs: "6px", md: "8px" },
                          py: { xs: "1px", md: "2px" },
                          borderRadius: "999px",
                          border: "1px solid",
                          borderColor:
                            typeof item.current === "number" &&
                            item.current >= item.min
                              ? "rgba(76,175,80,0.5)"
                              : "rgba(239,83,80,0.5)",
                          backgroundColor:
                            typeof item.current === "number" &&
                            item.current >= item.min
                              ? "rgba(76,175,80,0.12)"
                              : "rgba(239,83,80,0.12)",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: { xs: "0.5rem", md: "0.72rem" },
                            fontWeight: 600,
                            color:
                              typeof item.current === "number" &&
                              item.current >= item.min
                                ? "#81C784"
                                : "#EF9A9A",
                            lineHeight: 1.2,
                            letterSpacing: "0.02em",
                          }}
                        >
                          Min {item.min}
                        </Typography>
                      </Box>
                    ) : null}
                  </Box>
                </Box>
              ))}
            </Box>

            <Box
              sx={{
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "12px",
                overflow: "hidden",
                background:
                  "linear-gradient(180deg, rgba(22,23,30,0.84) 0%, rgba(16,17,20,0.9) 100%)",
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                width: "100%",
                mt: { xs: "2px", md: 0 },
                height: { xs: "62vh", sm: "65vh", md: "auto" },
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  background: "transparent",
                  border: "none",
                  backdropFilter: "blur(4px)",
                  borderRadius: 0,
                  overflow: "auto",
                  flex: 1,
                  minHeight: 0,
                  maxHeight: "none",
                }}
              >
                <Table stickyHeader sx={{ minWidth: 980 }}>
                  <TableHead>
                    <TableRow
                      sx={{
                        borderBottom: "1px solid rgba(255,255,255,0.2)",
                        "& .MuiTableCell-head": {
                          background:
                            "linear-gradient(90deg, rgba(72,23,54,0.98) 0%, rgba(103,37,28,0.98) 100%)",
                        },
                      }}
                    >
                        {[
                          { label: "Sr No" },
                          { label: "Auction No" },
                          { label: "MCA No" },
                          { label: "Name of the player", sortKey: "name" },
                          { label: "Gender" },
                          { label: "Age" },
                          { label: "Set" },
                          { label: "Role" },
                          // { label: "Runs" },
                          // { label: "Matches" },
                          // { label: "Wickets" },
                          { label: "Base price" },
                          { label: "Category" },
                          { label: "Sold for" },
                          { label: "Status" },
                        ].map(({ label, sortKey }, idx) => {
                        const isActive = sortKey && sortConfig?.key === sortKey;
                        const isSortable = Boolean(sortKey);
                        const direction = isActive
                          ? sortConfig?.direction
                          : "asc";
                        return (
                          <TableCell
                            key={idx}
                            sx={{
                              color: "#fff",
                              border: "none",
                              fontWeight: "600",
                              fontSize: "16px",
                              cursor: isSortable ? "pointer" : "default",
                              userSelect: "none",
                            }}
                            onClick={() => {
                              if (!sortKey) return;
                              setSortConfig((prev) =>
                                prev?.key === sortKey
                                  ? {
                                      key: sortKey,
                                      direction:
                                        prev.direction === "asc"
                                          ? "desc"
                                          : "asc",
                                    }
                                  : { key: sortKey, direction: "asc" },
                              );
                            }}
                          >
                            <Box display="flex" alignItems="center" gap="4px">
                              {label}
                              {isSortable && (
                                <span
                                  style={{
                                    fontSize: "14px",
                                    opacity: isActive ? 1 : 0.5,
                                  }}
                                >
                                  {direction === "asc" ? (
                                    <SwapVertIcon />
                                  ) : (
                                    <SwapVertIcon />
                                  )}
                                </span>
                              )}
                            </Box>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayedPlayers
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      ?.map((player: any, index: number) => {
                        const soldStatus =
                          player.auctionResult === "Sold"
                            ? {
                                label: "Sold",
                                background: "#7DC789",
                                color: "##212120",
                              }
                            : player.auctionResult === "Unsold"
                              ? {
                                  label: "Unsold",
                                  background: "#F8A6A6",
                                  color: "#212120",
                                }
                              : null;

                        const { runs, matches, wickets } =
                          extractStatByRole(player);

                        return (
                          <TableRow
                            key={player.playerId}
                            sx={{
                              borderBottom: "1px solid rgba(255,255,255,0.14)",
                              "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.03)",
                              },
                            }}
                          >
                            <TableCell sx={commonCellStyles}>
                              {page * rowsPerPage + index + 1}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {player?.auctionNumber ?? "--"}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {player?.MCANo ?? "--"}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {player.name}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {player?.gender || "--"}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {player?.playerAge ?? player?.age ?? "--"}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {player?.set || player?.Set || player?.Set__c || "--"}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {player.role}
                            </TableCell>

                            <TableCell sx={commonCellStyles}>
                              {player.basePrice != null
                                ? `₹${player.basePrice.toLocaleString("en-IN")}`
                                : "--"}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {getPlayerCategory(player)}
                            </TableCell>

                            <TableCell sx={commonCellStyles}>
                              {player.winningBid != null
                                ? `₹${player.winningBid.toLocaleString("en-IN")}`
                                : "--"}
                            </TableCell>
                            <TableCell sx={commonCellStyles}>
                              {soldStatus ? (
                                <Chip
                                  label={soldStatus.label}
                                  sx={{
                                    color: soldStatus.color,
                                    background: soldStatus.background,
                                    borderRadius: "8px",
                                    height: "36px",
                                    minWidth: "83px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                />
                              ) : (
                                "--"
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={displayedPlayers?.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                sx={{
                  color: "#fff",
                  borderTop: "1px solid rgba(255,255,255,0.12)",
                  flexShrink: 0,
                  "& .MuiToolbar-root": {
                    px: { xs: 1, md: 2 },
                    flexWrap: { xs: "wrap", md: "nowrap" },
                    rowGap: { xs: "6px", md: 0 },
                  },
                  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                    {
                      color: "#fff",
                    },
                  "& .MuiInputBase-root": {
                    color: "#fff",
                  },
                  "& .MuiSvgIcon-root": {
                    fill: "#fff",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TeamsDashboard;
